import { ChangeDetectionStrategy, Component, inject, OnInit, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DynamicDialogConfig, DynamicDialogRef } from '../../../core/services/dialog';
import { NotificationsComponent } from '../../../pages/notifications/notifications-component';
import { UpdatesComponent } from '../../../pages/updates/updates-component';
import { TranslatePipe } from '../../pipes/translate/translate.pipe';

/**
 * NotificationsAndAlertsComponent component.
 * Provides UI presentation and event handling for notifications and alerts component.
 */
@Component({
  selector: 'app-notifications-and-alerts',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, NotificationsComponent, UpdatesComponent, TranslatePipe],
  templateUrl: './notifications-and-alerts.component.html',
  styleUrls: ['./notifications-and-alerts.component.scss'],
})
export class NotificationsAndAlertsComponent implements OnInit {
  /** Injected service for config. */
  private config = inject(DynamicDialogConfig);
  /** Injected service for dialog ref. */
  private dialogRef = inject(DynamicDialogRef);

  /** Property active tab. */
  activeTab = signal<'notifications' | 'alerts'>('notifications');

  /**
   * Lifecycle hook that runs on component initialization.
   */
  ngOnInit(): void {
    if (this.config.data?.activeTab) {
      this.activeTab.set(this.config.data.activeTab);
    }
  }

  /**
   * Handles on close logic.
   */
  onClose(): void {
    this.dialogRef.close();
  }
}
